import { Tooltip } from '@mantine/core';
import React, { forwardRef } from 'react';
import type { TooltipProps } from '@mantine/core';

export const TooltipWithRef = forwardRef<
  HTMLDivElement,
  TooltipProps & { children: React.ReactNode }
>(({ children, ...props }, ref) => (
  <Tooltip ref={ref} {...props}>
    {children}
  </Tooltip>
));
TooltipWithRef.displayName = 'TooltipWithRef';
